//import * as tapable from "tapable";

import { bootMap, destructMap } from "./map-init";
//import { wrap } from "module";

// TODO:

// Plugins import

export default class Core {
  constructor(elID) {
    this._plugins = [];
    this.subs = [];
    this.hooks = {
      //All the hooks for the map goes here
      // addShape: new tapable.SyncHook(["featureId"]),
      // changeLayer: new tapable.SyncHook(["layer"]),
      // changedLayer: new tapable.SyncHook(["layer"]),
      // newMessage: new tapable.SyncHook(["message"]),
      // gotMessage: new tapable.SyncHook()
    };
    this.bindMap(elID);
    this.el = {
      itms: [],
      childrens: [],
      append: function(itm) {
        this.itms.push(itm);
      },
      appendChild: function(child) {
        this.childrens.push(child);
      }
    };
    this._initPortSubs();
    //this.el = document.getElementById(elID);
  }
  bindMap(elID) {
    let requestAnimationFrame =
      window.requestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.msRequestAnimationFrame;
    requestAnimationFrame(() => {
      var element = document.getElementById(elID);
      if (element) {
        var ph = this.el;
        this.el = element;
        for (var itm of ph.itms) this.el.append(itm);
        for (var child of ph.childrens) this.el.appendChild(child);
      } else {
        //TODO Handle error
      }
    });
  }
  init(config, elm, options) {
    //Add Map

    this.config = config;
    this.options = options || {
      target: "ol-map",
      center: [-12350000.17245, 4705131.1812],
      zoom: 7,
      maxZoom: 15,
      minZoom: 3
    };

    this.elm = elm;
    this._bootMap(this.options);
  }

  destruct() {
    
    if (this.data) destructMap(this.data);
    if(this._plugins && this._plugins.length)
    {
      for(let plugin of this._plugins)
      {
        try
        {
          plugin.destruct(this);
        }
        catch (e)
        {
          console.error("Unable to blow up the plugin!");
        }
      }
    }
    if(this.subs && Object.keys(this.subs).length)
    {
      console.warn("Found subscriptions that should have been removed. This is probably caused by a bad destructor. Forcibly removing these items");
      console.warn(Object.keys(this.subs));
      for(let sub of Object.keys(this.subs))
      {
        console.warn("Unmapping: " + sub);
        this.unmapCmd(sub);
      }
    }
  }
  _initPortSubs() {
    this.mapCmd("setMapServices", vals => {
      debugger;
      wrap.ags = {}
      for(var svc of vals)
        wrap.ags[svc.key] = svc;
    }, true);
  }
  _bootMap(options) {
    // options is the map options, and config is coming from yaml files
    this.data = bootMap(options, this.config);

  }

  getMap() {
    return this.data.map;
  }
  render() {}

  // brake() {
  //   this.hooks.brake.call();
  // }
  // newMessage(message) {
  //   this.hooks.newMessage.call(message);
  // }
  // moveMap(x, y) {
  //   // this.map.
  // }

  register(plugins) {
    
    for (let pluginWithOptions of plugins) {
      console.log(pluginWithOptions);
      let [plugin, options] = pluginWithOptions;
      this.initPlugin(plugin, options);
    }
  }

  initPlugin(Plugin, options) {
    let plugin = new Plugin();
    this._plugins.push(plugin);
    this.applyToPlugin(plugin, options);
    this.renderPlugin(plugin);
  }

  applyToPlugin(plugin, options) {
    plugin.apply(this, options);
  }
  renderPlugin(plugin) {
    // console.log(this)
    // plugins create an element and embed the elm object in it and then returns that element

    if (typeof plugin !== "undefined") {
      let el = plugin.render();
      if (this.el instanceof Element || this.el instanceof HTMLDocument) {
        this.el.append(plugin.render() || "");
      }
    }
  }

  // Stuff related to changing layers and extends plugins can hook to this and run these functions
  _changeLayer(layer) {
    console.log("Layer is changed to layer", layer, this);
  }

  // _showLayerByName(layerName, opacity) {
  //   showLayerByName.call(this.data.map, layerName, opacity);
  // }

  zoomToExtned(extend) {
    this.data.map.getView().fit(extend, {
      size: this.data.map.getSize(),
      duration: 1000
    });
  }

  addShape(featureId) {
    this.hooks.newMessage.call(featureId);
  }

  mapCmd(name, f, system) {
    let fn = val => {
      let requestAnimationFrame =
        window.requestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.msRequestAnimationFrame;
      requestAnimationFrame(() => {
        try {
          f(val);
        } catch (ex) {
          console.log(
            "Handler for " + name + " encountered an unhandled exception"
          );
          console.log(ex);
        }
      });
    };
    if(!system)
      this.subs[name] = fn;
    if (this.elm) {
      if (this.elm.ports[name]) {
        this.elm.ports[name].subscribe(fn);
      }
    }
  }

  unmapCmd(name) {
    if (this.subs[name]) {
      let fn = this.subs[name];
      if (this.elm) {
        if (this.elm.ports[name]) {
          this.elm.ports[name].unsubscribe(fn);
        }
      }
      this.subs[name] = null;
      delete this.subs[name];
    }
  }

  unmapCmds(names) {
    for (let name of names) {
      this.unmapCmd(name);
    }
  }

  emit(name, value) {
    if (!value) value = null;
    if (this.elm) {
      if (this.elm.ports[name]) {
        try {
          this.elm.ports[name].send(value);
        } catch (ex) {
          console.log("Error sending data. Is it in the corrct format?");
          console.log(ex);
        }
      } else {
        console.log(
          "Unable to send value to a port named " + name + " as it didnt exist!"
        );
        debugger;
      }
    }
  }

  getMap() {
    if (this.data) return this.data.map;
    return null;
  }
}
